import { action } from 'typesafe-actions';
import { Types, ManifestationDataProps } from './types';

// Update Manifestations
export const updateManifestationsSettings = (customerId: string) =>
  action(Types.UPDATE_MANIFESTATIONS_SETTINGS, { customerId });

// Load Manifestations
export const loadManifestations = (customerId: string) =>
  action(Types.LOAD_MANIFESTATIONS, { customerId });
export const loadManifestationsSuccess = (
  manifestations: ManifestationDataProps[]
) => action(Types.LOAD_MANIFESTATIONS_SUCCESS, { manifestations });
export const loadManifestationsFailure = (error: unknown) =>
  action(Types.LOAD_MANIFESTATIONS_FAILURE, { error });
